import { Component, OnInit } from '@angular/core';
import { RssService } from '../../services/rss.service';
import { AlertOverviewService } from '../../services/alert-overview.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  public rss: any;
  public alerts: any;
  public overview: any;
  public realtime: boolean = true;
  constructor(private rssService: RssService, private alertOverviewService: AlertOverviewService) { }

  ngOnInit(): void {
    this.getRSS();
    this.getOverview();
  }

  getRSS(): void {
    this.rssService.get()
        .subscribe(rss => this.rss = rss);
  }

  getOverview(){
    this.alertOverviewService.get()
      .subscribe(overview => {
        this.overview = overview;
        this.realtime = this.alertOverviewService.realtime;
      });
  }

}
